import { FC, memo } from 'react';
import Typography from '@ixigo/iui/Typography';
import smartSupportIcon from '../../images/smartSupport.svg';
import NPSCollectorV2 from '../NPSCollector/NPSCollectorV2';

interface SummaryProps {
    summary?: string | null;
    bookingId?: string;
    userId?: string;
}

/* eslint-disable react/prop-types */

const Summary: FC<SummaryProps> = memo(({ summary, bookingId, userId }) => {
    // Early return if no summary
    if (!summary) return null;

    // Common gradient classes
    const gradientClasses = 'bg-gradient-to-r from-yellow-800 via-orange-500 to-pink-700';
    const backgroundClasses = 'bg-orange-50';

    return (
        <div className='relative bg-neutral-100/50 rounded-[20px]'>
            {/* Summary label with icon */}
            <div className={`absolute -top-[0.8rem] left-4 z-10 p-[2px] rounded-full ${gradientClasses}`}>
                <div className={`flex items-center gap-2 px-3 py-1.5 ${backgroundClasses} rounded-full`}>
                    <img src={smartSupportIcon} alt='Summary' className='w-4 h-4' />
                    <Typography
                        variant='body-sm'
                        fontWeight='medium'
                        className={`${gradientClasses} bg-clip-text text-transparent`}
                    >
                        AI Summary
                    </Typography>
                </div>
            </div>

            {/* Main container with gradient border and cream background */}
            <div className={`relative rounded-[20px] ${gradientClasses} p-[2px]`}>
                <div className={`${backgroundClasses} rounded-[18px] p-4 pt-6 pr-2.5`}>
                    <Typography
                        variant='body-sm'
                        className='text-gray-800 leading-relaxed' // ${isExpanded ? '' : 'line-clamp-3'}
                        role='region'
                        aria-label='Booking summary'
                    >
                        {summary}
                    </Typography>
                    {/* <button
                        onClick={handleToggle}
                        className='text-blue-400 cursor-pointer focus:outline-none mt-2 text-sm font-medium'
                        type='button'
                        aria-label={`${isExpanded ? 'Show less' : 'Read more'} summary`}
                        aria-expanded={isExpanded}
                    >
                        {isExpanded ? 'Read less' : 'Read more'}
                    </button> */}
                </div>
            </div>

            {/* Feedback Section */}
            <div className='px-4 py-2 rounded-b-[20px]'>
                <NPSCollectorV2
                    question='Was this summary helpful?'
                    campaignId='IXICAMP0017170390'
                    bookingId={bookingId}
                    userId={userId}
                    summary={summary}
                />
            </div>
        </div>
    );
});

Summary.displayName = 'Summary';

export default Summary;
